import PageWrapper from "@/components/PageWrapper.tsx";
import ProductCardSkeleton from "./components/ProductCardSkeleton.tsx";

export default function PartnerSingleLoading() {
  return (
    <PageWrapper backPath="/partners">
      <div className="min-h-screen bg-dark pb-6">
        {/* Hero banner skeleton — matches PartnerSinglePage's aspect-[16/10] */}
        <div className="w-full aspect-[16/10] skeleton" />

        <div className="container pt-4">
          {/* Partner title + description */}
          <div className="w-1/2 h-6 skeleton rounded mb-2" />
          <div className="space-y-1.5">
            <div className="w-full h-3 skeleton rounded" />
            <div className="w-2/3 h-3 skeleton rounded" />
          </div>

          {/* Products label */}
          <div className="w-28 h-4 skeleton rounded mt-6 mb-3" />

          {/* 2-col grid of marketplace tiles — same layout as the live page */}
          <div className="grid grid-cols-2 gap-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <ProductCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
